type GetVerticalTicketClipPathProps = {
  width: number;
  columnOneHeight: number;
  columnTwoHeight: number;
  gap: number;
  gapInset: number;
  radius: number;
};

export const getVerticalTicketBackgroundClipPath = ({
  width,
  columnOneHeight,
  columnTwoHeight,
  gap,
  gapInset,
  radius,
}: GetVerticalTicketClipPathProps) => {
  return `
    M 0 ${radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${width - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${columnOneHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${gapInset - radius}
    a ${radius} ${radius} 0 0 0 -${radius} ${radius}
    v ${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} ${radius}
    h ${gapInset - radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${columnTwoHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${width - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    v -${columnTwoHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${gapInset - radius}
    a ${radius} ${radius} 0 0 0 ${radius} -${radius}
    v -${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} -${radius}
    h -${gapInset - radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    Z
  `
    .replace(/\s+/g, " ")
    .trim();
};

type GetHorizontalTicketClipPathProps = {
  height: number;
  columnOneWidth: number;
  columnTwoWidth: number;
  gap: number;
  gapInset: number;
  radius: number;
};

export const getHorizontalTicketBackgroundClipPath = ({
  height,
  columnOneWidth,
  columnTwoWidth,
  gap,
  gapInset,
  radius,
}: GetHorizontalTicketClipPathProps) => {
  return `
    M 0 ${radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${columnOneWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} ${radius}
    h ${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} -${radius}
    v -${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${columnTwoWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${height - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${columnTwoWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    v -${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} -${radius}
    h -${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} ${radius}
    v ${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${columnOneWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    Z
  `
    .replace(/\s+/g, " ")
    .trim();
};
